import { render, staticRenderFns } from "./ViewClipModal.vue?vue&type=template&id=3d23a830&"
import script from "./ViewClipModal.vue?vue&type=script&lang=js&"
export * from "./ViewClipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports